import { useState } from "react";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import { useNavigate, Link } from "react-router-dom";
import AnimatedDealFlow from "../components/AnimatedDealFlow";
import { doc, setDoc } from "firebase/firestore";
import { db } from "../firebase";

export default function Register() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [nombre, setNombre] = useState("");
  const [telefono, setTelefono] = useState("");
  const [objetivo, setObjetivo] = useState("");
  const [referencia, setReferencia] = useState("");
  const [aceptado, setAceptado] = useState(false);
  const [tipoUsuario, setTipoUsuario] = useState("fisica");
  const [cif, setCif] = useState("");
  const [empresa, setEmpresa] = useState("");
  const [sector, setSector] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [fechaNacimiento, setFechaNacimiento] = useState("");
  const [provincia, setProvincia] = useState("");
  const [cargo, setCargo] = useState("");
  const [linkedin, setLinkedin] = useState("");
  const [experiencia, setExperiencia] = useState("");
  const [intereses, setIntereses] = useState([]);
  const [tamanoEmpresa, setTamanoEmpresa] = useState("");

  const inputClass = "w-full border border-gray-300 text-gray-800 text-sm px-3 py-2 rounded placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-400 transition";

  const registerWithEmail = async () => {
    setError("");
    if (!aceptado) return setError("Debes aceptar los términos y condiciones.");
    if (!nombre || !telefono || !objetivo || !email || !password) {
      return setError("Por favor, completa todos los campos obligatorios.");
    }
    setLoading(true);

    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      await setDoc(doc(db, "users", user.uid), {
        nombre,
        email,
        telefono,
        objetivo,
        referencia,
        tipoUsuario,
        empresa: tipoUsuario === "juridica" ? empresa : null,
        cif: tipoUsuario === "juridica" ? cif : null,
        sector: tipoUsuario === "juridica" ? sector : null,
        cargo: tipoUsuario === "juridica" ? cargo : null,
        fechaNacimiento: tipoUsuario === "fisica" ? fechaNacimiento : null,
        provincia,
        linkedin,
        experiencia,
        intereses,
        tamanoEmpresa,
        role: "normal",
        createdAt: new Date(),
      });

      navigate("/");
    } catch (err) {
      console.error(err.code);
      if (err.code === "auth/invalid-email") setError("El correo electrónico no es válido.");
      else if (err.code === "auth/email-already-in-use") setError("Este correo ya está registrado.");
      else if (err.code === "auth/weak-password") setError("La contraseña debe tener al menos 6 caracteres.");
      else setError("Error desconocido. Inténtalo de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 md:grid-cols-2 font-sans">
      <div className="relative bg-gradient-to-b from-[#fffceb] to-white flex flex-col justify-center items-center p-10 text-center overflow-hidden">
        <div className="absolute w-96 h-96 bg-yellow-100 rounded-full opacity-30 blur-3xl top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[-1] pointer-events-none" />
        <img src="/noltrade_gpt.png" alt="Noltrade" className="h-12 mb-6 drop-shadow-md" />
        <h2 className="text-3xl font-bold text-gray-800 mb-4 z-10">
          Impulsa tu próximo <span className="text-yellow-600">negocio digital</span>
        </h2>
        <p className="text-gray-600 max-w-sm z-10">
          Conecta con compradores, vende tu startup o invierte en empresas con potencial. El futuro se negocia aquí.
        </p>
        <AnimatedDealFlow />
      </div>

      <div className="flex items-center justify-center p-10 bg-white">
        <div className="w-full max-w-2xl">
          <h1 className="text-2xl font-bold text-gray-800 mb-6">Crea tu cuenta</h1>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <input type="text" placeholder="Nombre completo" className={inputClass} onChange={(e) => setNombre(e.target.value)} value={nombre} />
            <input type="tel" placeholder="Teléfono de contacto" className={inputClass} onChange={(e) => setTelefono(e.target.value)} value={telefono} />
            <input type="email" placeholder="Correo electrónico" className={`${inputClass} col-span-full`} onChange={(e) => setEmail(e.target.value)} value={email} />
            <input type="password" placeholder="Contraseña" className={`${inputClass} col-span-full`} onChange={(e) => setPassword(e.target.value)} value={password} />
          </div>

          <div className="flex gap-4 mt-4 text-sm text-gray-700">
            <label className="flex items-center gap-2">
              <input type="radio" name="tipoUsuario" value="fisica" checked={tipoUsuario === "fisica"} onChange={() => setTipoUsuario("fisica")} /> Persona física
            </label>
            <label className="flex items-center gap-2">
              <input type="radio" name="tipoUsuario" value="juridica" checked={tipoUsuario === "juridica"} onChange={() => setTipoUsuario("juridica")} /> Empresa
            </label>
          </div>

          {tipoUsuario === "juridica" && (
            <>
              <input type="text" placeholder="Nombre de la empresa" className={`${inputClass} mt-4`} onChange={(e) => setEmpresa(e.target.value)} value={empresa} />
              <input type="text" placeholder="CIF" className={`${inputClass} mt-2`} onChange={(e) => setCif(e.target.value)} value={cif} />
              <select className={`${inputClass} mt-2`} onChange={(e) => setSector(e.target.value)} value={sector}>
                <option value="">Selecciona un sector</option>
                <option value="tecnologia">Tecnología</option>
                <option value="salud">Salud</option>
                <option value="finanzas">Finanzas</option>
                <option value="educacion">Educación</option>
                <option value="otros">Otros</option>
              </select>
            </>
          )}

          <select className={`${inputClass} mt-4`} onChange={(e) => setObjetivo(e.target.value)} value={objetivo}>
            <option value="">¿Qué buscas en Noltrade?</option>
            <option value="comprar">Comprar un negocio</option>
            <option value="vender">Vender mi negocio</option>
            <option value="explorar">Explorar oportunidades</option>
          </select>

          <input type="text" placeholder="¿Cómo nos conociste? (opcional)" className={`${inputClass} mt-4`} onChange={(e) => setReferencia(e.target.value)} value={referencia} />

          {/* Fecha de nacimiento */}
{tipoUsuario === "fisica" && (
  <div className="mt-4">
    <label className="text-sm text-gray-600 block mb-1">Fecha de nacimiento</label>
    <input
      type="date"
      className="border p-2 rounded text-gray-900 w-full placeholder:text-gray-400 text-sm"
      value={fechaNacimiento}
      onChange={(e) => setFechaNacimiento(e.target.value)}
    />
  </div>
)}


          <input type="text" placeholder="Provincia o ciudad" className={`${inputClass} mt-4`} onChange={(e) => setProvincia(e.target.value)} value={provincia} />

          {tipoUsuario === "juridica" && (
            <input type="text" placeholder="Tu cargo en la empresa" className={`${inputClass} mt-4`} onChange={(e) => setCargo(e.target.value)} value={cargo} />
          )}

          <input type="url" placeholder="LinkedIn (opcional)" className={`${inputClass} mt-4`} onChange={(e) => setLinkedin(e.target.value)} value={linkedin} />

          <select className={`${inputClass} mt-4`} onChange={(e) => setExperiencia(e.target.value)} value={experiencia}>
            <option value="">¿Tienes experiencia en M&A?</option>
            <option value="si">Sí, he comprado o vendido empresas</option>
            <option value="no">No, sería mi primera vez</option>
          </select>

          <div className="mt-4">
  <label className="text-sm text-gray-600 block mb-1">Sectores de interés</label>
  <div className="grid grid-cols-2 gap-2 text-sm text-gray-700">
    {["tecnología", "salud", "educación", "retail", "industria", "otros"].map((item) => (
      <label key={item} className="flex items-center gap-2">
        <input
          type="checkbox"
          value={item}
          checked={intereses.includes(item)}
          onChange={(e) => {
            if (e.target.checked) {
              setIntereses([...intereses, item]);
            } else {
              setIntereses(intereses.filter((i) => i !== item));
            }
          }}
        />
        {item.charAt(0).toUpperCase() + item.slice(1)}
      </label>
    ))}
  </div>
</div>


          <select className={`${inputClass} mt-4`} onChange={(e) => setTamanoEmpresa(e.target.value)} value={tamanoEmpresa}>
            <option value="">Tamaño de empresa que buscas</option>
            <option value="-100k">Facturación menor de 100.000€</option>
            <option value="100k-500k">100.000€ – 500.000€</option>
            <option value="500k-1m">500.000€ – 1M€</option>
            <option value="1m+">Más de 1M€</option>
          </select>

          <label className="flex items-start gap-2 text-sm text-gray-700 mt-4">
            <input type="checkbox" checked={aceptado} onChange={() => setAceptado(!aceptado)} />
            <span>
              Acepto los <Link to="/legal/aviso" className="text-yellow-600 hover:underline">términos legales</Link> y la <Link to="/legal/privacidad" className="text-yellow-600 hover:underline">política de privacidad</Link>.
            </span>
          </label>

          <button onClick={registerWithEmail} className="w-full bg-yellow-500 hover:bg-yellow-600 text-white font-semibold px-4 py-2 rounded transition mt-6">
            Registrarse
          </button>

          {error && (
            <div className="bg-red-100 text-red-700 p-2 rounded text-center text-sm mt-4">
              {error}
            </div>
          )}

          <p className="text-center text-gray-500 text-sm mt-6">
            ¿Ya tienes cuenta? <Link to="/login" className="text-yellow-600 hover:underline">Iniciar sesión</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
